import { fr_CA } from '@docupet/component-library';
export default {
  ...fr_CA,
  discount: {
    notApplyTip:
      "Les codes promotionnels ne s'appliquent pas aux frais de licence pour animaux de compagnie, aux frais de retard, aux étiquettes de remplacement pour animaux de compagnie, aux articles groupés ou aux articles en vente spécifiques.",
  },
};
